export const CRAWLER_PICKER_ANNOUNCEMENT_STRINGS = {
  title: 'Find the crawlers you care about faster',
  body: 'You can now select a whole category or individual crawlers, and search by name or user agent. We also removed Gemini. Google-Extended is only a robots.txt setting, and the crawling is done by Googlebot, under Search Engines.',
} as const;

export const CRAWLER_PICKER_ANNOUNCEMENT_STORAGE_KEY_PREFIX = 'dashboard-crawler-picker-banner-dismissed';

export const CRAWLER_PICKER_RELEASE_DATE = '2026-10-10T00:00:00Z';
export const CRAWLER_PICKER_ANNOUNCEMENT_LIFETIME_DAYS = 30;

const ONE_DAY_MS = 24 * 60 * 60 * 1000;

export const CRAWLER_PICKER_ANNOUNCEMENT_HIDE_AFTER =
  Date.parse(CRAWLER_PICKER_RELEASE_DATE) + CRAWLER_PICKER_ANNOUNCEMENT_LIFETIME_DAYS * ONE_DAY_MS;

export function isCrawlerPickerAnnouncementRetired(now: number): boolean {
  return now >= CRAWLER_PICKER_ANNOUNCEMENT_HIDE_AFTER;
}
